export default __webpack_public_path__ + "static/media/share-file.5689208a.svg";